module.exports = __webpack_public_path__ + "static/media/karly-jones-xBqYLnRhfaI-unsplash.a0aa5ff2.jpg";